import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import type { IEnergyAsset, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getEnergyAssets = async (
  params: DataQueryParams = {},
): Promise<IPage<IEnergyAsset>> =>
  await getRequest(API_BASE_PATHS.ENERGY_ASSETS, formatQueryParams(params));

export const getEnergyAsset = async (id: string): Promise<IEnergyAsset> =>
  await getRequest(`${API_BASE_PATHS.ENERGY_ASSETS}/${id}`);

export const addEnergyAsset = async (body: any) =>
  await postRequest(API_BASE_PATHS.ENERGY_ASSETS, {}, body);

export const updateEnergyAsset = async (id: string, body: any) =>
  await patchRequest(`${API_BASE_PATHS.ENERGY_ASSETS}/${id}`, {}, body);

export const deleteEnergyAsset = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.ENERGY_ASSETS}/${id}`, {});
